winlineBatcherLowWin = {};
winlineBatcherLowWin.useWildSymbolAnim = false;

winlineBatcherLowWin.batch = function (winData, controllerName, slotMachine) {
  let currentStake =
    resourceManager.getController("stakeController").CurrentStake;
  let greaterThanStakeWin = winData.totalLineWinnings > currentStake;
  let inFreespins = gameController.inFreeSpins;
  var i, j, k, l, m;
  var symbolIds = [];
  var sortedGroups = [];
  var animations = [];
  var group;

  // First get unique sorted symbols so we can create ascending symbol groups
  for (i = 0; i < winData.winningLines.length; i++) {
    if (symbolIds.indexOf(winData.winningLines[i].symbol.value) === -1) {
      symbolIds.push(winData.winningLines[i].symbol.value);
    }
  }
  symbolIds.sort();

  // Create a sorted groups array. This stores all sorted data for each group
  for (i = 0; i < symbolIds.length; i++) {
    sortedGroups.push({ numSymbols: [] });
  }

  // Now find all winlines for this symbol and sort in number of symbols, then winline ascending order
  for (i = 0; i < winData.winningLines.length; i++) {
    var symbolValue = winData.winningLines[i].symbol.value;
    var sortedGroupsIndex = symbolIds.indexOf(symbolValue);
    group = sortedGroups[sortedGroupsIndex];

    if (group.numSymbols.indexOf(winData.winningLines[i].occurrences) === -1) {
      group.numSymbols.push(winData.winningLines[i].occurrences);
    }
  }

  for (i = 0; i < sortedGroups.length; i++) {
    sortedGroups[i].numSymbols.sort();
  }

  // Now create winline animation for each group
  for (i = 0; i < sortedGroups.length; i++) {
    var symbolIndex = symbolIds[i];
    var maxSymbolsInWinline = 0;
    group = [];
    for (j = 0; j < sortedGroups[i].numSymbols.length; j++) {
      var numSymbols = sortedGroups[i].numSymbols[j];
      for (k = 0; k < winData.winningLines.length; k++) {
        if (
          winData.winningLines[k].symbol.value === symbolIndex &&
          winData.winningLines[k].occurrences === numSymbols
        ) {
          group.push(winData.winningLines[k]);
          if (maxSymbolsInWinline < numSymbols) {
            maxSymbolsInWinline = numSymbols;
          }
        }
      }
    }

    // Add to animation sequence
    var symbolAnimations = [];
    var soundFile =
      resourceManager.getController(controllerName).Props.winlineSound;

    for (k = 0; k < group.length; k++) {
      animations.push({
        type: "Winline",
        sound: sprintf(soundFile, k),
        data: group[k],
        slotMachine: slotMachine,
      });
      for (l = 0; l < group[k].occurrences; l++) {
        var row = group[k].positions[l].row;
        var reel = group[k].positions[l].reel;
        // Check for unqique
        var unique = true;
        for (m = 0; m < symbolAnimations.length; m++) {
          if (
            symbolAnimations[m].reel == reel &&
            symbolAnimations[m].row === row
          ) {
            unique = false;
          }
        }

        if (unique) {
          symbolAnimations.push({
            reel: reel,
            row: row,
            symbolIndex: winlineBatcherLowWin.useWildSymbolAnim
              ? group[k].symbol.ids[l]
              : group[k].symbol.value,
            value: group[k].symbol.value,
            multiplier:
              group[k].multipliers !== undefined ? group[k].multipliers[l] : 1,
          });
        }
      }
    }

    var symbolSound = undefined;
    var symbolTemplate =
      resourceManager.getConfiguration().symbols[
        Object.keys(resourceManager.getConfiguration().symbols)[symbolIndex]
      ];
    if (typeof symbolTemplate.soundFile !== "undefined") {
      // Single sound for all wins on this winline
      symbolSound = symbolTemplate.soundFile;
    } else if (
      typeof symbolTemplate["soundFile_x" + maxSymbolsInWinline] !== "undefined"
    ) {
      // Different sound for wins on this winline
      symbolSound = symbolTemplate["soundFile_x" + maxSymbolsInWinline];
    }

    if (greaterThanStakeWin || inFreespins) {
      // only animate symbols if it the win is greater than the current win, or we are in freespins
      animations.push({
        type: "Symbol",
        sound: symbolSound,
        data: symbolAnimations,
        slotMachine: slotMachine,
      });
    }
  }

  return animations;
};

winlineBatcherLowWin.setUseWildSymbolAnim = function (val) {
  winlineBatcherLowWin.useWildSymbolAnim = val;
};

resourceManager.registerPlugIn("winlineBatcherLowWin", winlineBatcherLowWin);
